import { render, staticRenderFns } from "./c_home_coupon.vue?vue&type=template&id=706a9264&scoped=true"
import script from "./c_home_coupon.vue?vue&type=script&lang=js"
export * from "./c_home_coupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706a9264",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('706a9264')) {
      api.createRecord('706a9264', component.options)
    } else {
      api.reload('706a9264', component.options)
    }
    module.hot.accept("./c_home_coupon.vue?vue&type=template&id=706a9264&scoped=true", function () {
      api.rerender('706a9264', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfig/c_home_coupon.vue"
export default component.exports